import React from 'react';
import { Route, Switch } from 'react-router-dom';

import LandingPage from '../components/views/10_LandingPage/LandingPage';
import Chat from '../components/views/10_LandingPage/Chat';
import ChatNoAudio from '../components/views/10_LandingPage/ChatNoAudio';
import Call from '../components/views/10_LandingPage/Call';
import MyWebRTC from '../components/views/10_LandingPage/MyWebRTC';
import WebRTCComponent from '../components/views/10_LandingPage/vonage';
import MP3TestPage from '../components/views/10_LandingPage/MP3_TestPage';
import ShowResult from '../components/views/10_LandingPage/ShowResult';
//import LandingScenario from "../components/views/10_LandingPage/LandingScenario";
//import LandingDev from '../components/views/10_LandingPage/LandingDev';

import Page404 from "../components/views/ErrorPages/Page404";

const Routes = () => {

    return (
        <Switch>
            {/* null-->누구나 접근가능, true-->로그인한 사용자만 접근가능, false-->로그인 안한 사용자만 접근가능 */}
			<Route exact path="/call" component={Call} />
			<Route exact path="/chat_no_audio" component={ChatNoAudio} />
			<Route exact path="/webrtc" component={MyWebRTC} /> 
			<Route exact path="/" component={WebRTCComponent} />
			{/* <Route exact path="/" component={MP3TestPage} /> */}
            <Route exact path="/result" component={ShowResult} />
			{/* <Route exact path="/scenario" component={Auth(LandingScenario, true)} />
			<Route exact path="/develope" component={Auth(LandingDev, true)} /> */}
            <Route component={Page404} exact />

        </Switch>
    );
};

export default Routes;